import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-sm capitalize leading-4" }

import LzIcon from './LzIcon.vue';
import { withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LzDropdownItem',
  props: {
    value: {},
    title: { default: '' },
    selected: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false }
  },
  emits: ['select'],
  setup(__props: any, { emit }) {

const props = __props;




function onClick() {
    emit('select', { value: props.value, label: props.title, selected: props.selected });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: onClick,
    class: "relative flex cursor-pointer items-center px-6 py-4 transition-colors hover:bg-black/10"
  }, [
    (_ctx.selected)
      ? (_openBlock(), _createBlock(LzIcon, {
          key: 0,
          name: "close-rize",
          class: "absolute -ml-4 h-2 w-2 stroke-current"
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1)
    ])
  ]))
}
}

})